import { DatabaseRecord } from "@/core/repos/table.repo";
import {
  ReportTable,
  ReportTableConfigs,
} from "../../components/report/ReportTable";
import { Suspense, useState } from "react";
import { ConfigProvider, Select } from "antd";
import { MODAL_THEME } from "@/core/themes/modal.theme";
import { INVOICE_REPORT_CONFIGS } from "./configs/invoice-report";
import { BILLING_REPORT_CONFIGS } from "./configs/billing-report";
import { AREA_REPORT_CONFIGS } from "./configs/area-report";
import { UNIT_TYPE_REPORT_CONFIGS } from "./configs/unit-type-report";
import { useSearchParams } from "react-router";
import { TRANSACTION_REPORT_CONFIGS } from "./configs/transaction-report";

function BillingReport() {
  const reportConfigs: { name: string; props: ReportTableConfigs<any, any> }[] =
    [
      BILLING_REPORT_CONFIGS,
      AREA_REPORT_CONFIGS,
      UNIT_TYPE_REPORT_CONFIGS,
      INVOICE_REPORT_CONFIGS,
      TRANSACTION_REPORT_CONFIGS,
    ];
  const [searchParams] = useSearchParams();
  const reportIndexParam = searchParams.get("type");
  const getParamIndex = () => {
    let index = 0;
    if (!reportIndexParam) return 0;
    try {
      index = parseInt(reportIndexParam);
      if (index > reportConfigs.length - 1) index = reportConfigs.length - 1;
    } catch (err) {}
    return index;
  };
  const [reportProps, setReportProps] = useState<ReportTableConfigs<
    DatabaseRecord,
    any
  > | null>(reportConfigs[getParamIndex()].props);
  const [reportIndex, setReportIndex] = useState(getParamIndex());
  const onReportSelect = (index: number) => {
    setReportIndex(index);
    setReportProps(reportConfigs[index].props);
  };

  return (
    <div>
      <ConfigProvider theme={MODAL_THEME}>
        <div className="mx-4 mt-6">
          <p className="mb-2 text-[16px] font-[400]">Chọn loại báo cáo:</p>
          <Select
            allowClear
            showSearch
            options={[
              {value: undefined, label: 'Chọn loại báo cáo'},
              ...reportConfigs.map((report, i) => ({
                value: i,
                label: report.name,
              }))
            ]}
            filterOption={(input, option) =>
              (option?.label ?? "")
                .toString()
                .toLowerCase()
                .includes(input.toLowerCase())
            }
            className="w-full"
            value={reportIndex}
            onChange={onReportSelect}
          />
        </div>
      </ConfigProvider>
      {reportProps != undefined ? (
        <ReportTable reportIndex={reportIndex} config={reportProps} />
      ) : null}
    </div>
  );
}

export default function BillingReportPage() {
  return (
    <Suspense>
      <BillingReport />
    </Suspense>
  );
}
